import $ from 'jquery';
import 'slick-carousel';

var $slider = $('.js-slider');

$slider.on('init', function () {
    $('.slider__load-image').hide();
});

$slider.slick({
    autoplay: true,
    autoplaySpeed: 7000,
    infinite: true,
    arrows: false,
    dots: true,
    draggable: false,
    responsive: [{
        breakpoint: 992,
        settings: {
            draggable: true,
            dots: false
        }
    }]
});
